module.exports = __webpack_public_path__ + "img/鍾小平.22be2379.png";